/**
 * Green Flag — UpcomingEligibleWidget
 *
 * Top-of-Events-page widget featuring a single upcoming event the user is
 * eligible to attend (age match + room for their gender). Vertical card:
 * hero image on top, date eyebrow + title + Sparks chip + full-width
 * sign-up button stacked below. The whole card is a navigation target to
 * the event details page.
 */

import { Box, chakra, Image, useSlotRecipe } from "@chakra-ui/react";
import dayjs from "dayjs";
import { SparksChip } from "../SparksChip/SparksChip";

export interface UpcomingEligibleWidgetProps {
  sparkId: number;
  title: string;
  startsAt: string;
  img: string;
  sparks?: number;
  sparkAvatars?: string[];
  sparksLocked?: boolean;
  onSignUp: () => void;
}

export function UpcomingEligibleWidget({
  title,
  startsAt,
  img,
  sparks,
  sparkAvatars,
  sparksLocked,
  onSignUp,
}: UpcomingEligibleWidgetProps) {
  const recipe = useSlotRecipe({ key: "upcomingEligibleWidget" });
  const styles = recipe({});

  return (
    <chakra.div
      css={styles.root}
      onClick={onSignUp}
      role="button"
      aria-label={`Sign up for ${title}`}
    >
      {img && <Image css={styles.image} src={img} alt={title} />}
      <Box css={styles.body}>
        <chakra.div css={styles.date}>
          {dayjs(startsAt).format("dddd, MMMM Do").toUpperCase()}
        </chakra.div>
        <chakra.div css={styles.title}>{title}</chakra.div>
        {sparks != null && (
          <Box css={styles.sparks}>
            <SparksChip
              count={sparks}
              avatars={sparkAvatars}
              locked={sparksLocked}
            />
          </Box>
        )}
        <chakra.button
          css={styles.signUp}
          onClick={(e) => {
            e.stopPropagation();
            onSignUp();
          }}
        >
          Sign Up
        </chakra.button>
      </Box>
    </chakra.div>
  );
}
